import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { FooterHeaderComponent } from '../footer-header/footer-header.component';
import { CommonModule } from '@angular/common';
import { FooterComponent } from "../footer/footer.component";

@Component({
  selector: 'app-helpandsupport',
  standalone: true,
  imports: [FooterHeaderComponent, CommonModule, FooterComponent],
  templateUrl: './helpandsupport.component.html',
  styleUrls: ['./helpandsupport.component.scss']
})
export class HelpandsupportComponent implements OnInit, OnDestroy {
  isStandalonePage = false;
  
  // Simple navigation
  currentCardIndex = 0;
  uniqueCards = [
    { category: 'payments', name: 'Payment Services', title: 'Change card or bank details' },
    { category: 'beneficiary', name: 'Beneficiary Management', title: 'Update beneficiary details' },
    { category: 'details', name: 'Personal Information', title: 'Change address or contact details' },
    { category: 'documents', name: 'Document Center', title: 'View your policy documents' },
    { category: 'adviser', name: 'Adviser Contact', title: 'Have a query about your policy' },
    { category: 'claims', name: 'Claims Support', title: 'Start the claims process' }
  ];

  constructor(private router: Router) {}

  ngOnInit() {
    this.isStandalonePage = !this.router.url.startsWith('/home');
  }

  ngOnDestroy() {
    // Clean up
  }
  
  scrollToCard(index: number) {
    this.currentCardIndex = index;
    this.moveCards();
  }

  private moveCards() {
    const container = document.querySelector('.category-grid') as HTMLElement;
    if (container) {
      const translateX = -(this.currentCardIndex * 374); // 350px card + 24px gap
      container.style.transform = `translateX(${translateX}px)`;
      container.style.transition = 'transform 0.3s ease';
    }
  }
}
